module.exports = __webpack_public_path__ + "static/co-fes-logo-dark@2x-031de77fb1d367498121650d87ea8b89.png";